$('.subtabs-wrapper').each(function(index, value) {
  $(value).find('.vc_btn3').first().addClass('subtab-active');
  $($(value).find('.vc_btn3').first().attr('href')).fadeIn('fast');

  $(value).find('.vc_btn3').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    $(value).find('.vc_btn3').removeClass('subtab-active');
    $(this).addClass('subtab-active');

    $(this).closest('.vc_tta-panel-body').find('.subtab').fadeOut('fast');
    $($(this).attr('href')).fadeIn('fast');
  });
});



// WEBPACK FOOTER //
// ./scripts/wpbakery/subtabs.js